import { Card, Statistic, Tooltip, Typography } from "antd";
import { useTranslation } from "react-i18next";
import {
  ClockCircleOutlined,
  RiseOutlined,
  TeamOutlined,
  CheckCircleOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import "./KpiCards.scss";

const { Text } = Typography;

function TitleWithInfo({ title, info }) {
  return (
    <span className="revi-kpi-card__title-row">
      <Text>{title}</Text>
      <Tooltip title={info} placement="top">
        <InfoCircleOutlined className="revi-kpi-card__info-icon" />
      </Tooltip>
    </span>
  );
}

export function KpiCards({ loading, summary, timeRangeLabel }) {
  // El rango ('7 dias', 'Todo el historico') ya viene traducido de quien
  // pinta esta fila: es la misma etiqueta que se ve en el selector.
  const { t } = useTranslation("motricity");
  const rango = timeRangeLabel || null;

  const totalSessions = summary?.totalSessions ?? 0;
  const activePatients = summary?.activePatients ?? 0;

  const avgDuration = totalSessions > 0 ? (summary?.avgDuration ?? 0) : null;
  const avgScore =
    summary?.avgSatisfaction != null && summary.avgSatisfaction > 0
      ? summary.avgSatisfaction
      : null;

  return (
    <div className="revi-kpi-grid">
      <Card
        className="revi-kpi-card revi-kpi-card--sessions"
        variant="outlined"
        loading={loading}
      >
        <div className="revi-kpi-card__row">
          <Statistic
            title={
              <TitleWithInfo
                title={t("kpi.sesiones.titulo")}
                info={t(
                  rango ? "kpi.sesiones.ayudaRango" : "kpi.sesiones.ayuda",
                  { rango },
                )}
              />
            }
            value={totalSessions}
          />
          <CheckCircleOutlined className="revi-kpi-card__icon revi-kpi-card__icon--sessions" />
        </div>
      </Card>

      <Card
        className="revi-kpi-card revi-kpi-card--patients"
        variant="outlined"
        loading={loading}
      >
        <div className="revi-kpi-card__row">
          <Statistic
            title={
              <TitleWithInfo
                title={t("kpi.pacientes.titulo")}
                info={t("kpi.pacientes.ayuda")}
              />
            }
            value={activePatients}
          />
          <TeamOutlined className="revi-kpi-card__icon revi-kpi-card__icon--patients" />
        </div>
      </Card>

      <Card
        className="revi-kpi-card revi-kpi-card--duration"
        variant="outlined"
        loading={loading}
      >
        <div className="revi-kpi-card__row">
          <Statistic
            title={
              <TitleWithInfo
                title={t("kpi.duracion.titulo")}
                info={t(
                  rango ? "kpi.duracion.ayudaRango" : "kpi.duracion.ayuda",
                  { rango },
                )}
              />
            }
            value={avgDuration === null ? "\u2014" : avgDuration}
            suffix={avgDuration === null ? "" : t("kpi.duracion.unidad")}
          />
          <ClockCircleOutlined className="revi-kpi-card__icon revi-kpi-card__icon--duration" />
        </div>
      </Card>

      <Card
        className="revi-kpi-card revi-kpi-card--score"
        variant="outlined"
        loading={loading}
      >
        <div className="revi-kpi-card__row">
          <Statistic
            title={
              <TitleWithInfo
                title={t("kpi.puntuacion.titulo")}
                info={t(
                  rango ? "kpi.puntuacion.ayudaRango" : "kpi.puntuacion.ayuda",
                  { rango },
                )}
              />
            }
            value={avgScore === null ? "\u2014" : avgScore}
            suffix={avgScore === null ? "" : t("kpi.puntuacion.unidad")}
          />
          <RiseOutlined className="revi-kpi-card__icon revi-kpi-card__icon--score" />
        </div>
      </Card>
    </div>
  );
}
